import React, { Component } from 'react'
import WindowBreakpoints from './WindowBreakpoints'
import { WINDOW_BREAKPOINTS } from 'lib/constants'

export default class AppWindowBreakpoints extends Component {
    render () {
        return <WindowBreakpoints breakpointSteps={WINDOW_BREAKPOINTS} {...this.props} />
    }
}
